import type { OnInit } from '@angular/core';
import { Component, inject } from '@angular/core';
import { NavigationEnd, Router, RouterOutlet } from '@angular/router';
import { filter } from 'rxjs/operators';
import { AppService } from './app.service';
import { AuthService } from './authentication/auth.service';
import { FileService } from './core/services/file.service';
import { NgClass } from '@angular/common';
import { ToasterComponent } from './core/components/toaster/toaster.component';
import { SidenavComponent } from './core/layout/sidenav/sidenav.component';
import { TopnavComponent } from './core/layout/topnav/topnav.component';
import { ConfirmDialog } from 'primeng/confirmdialog';

@Component({
  selector: 'app-root',
  templateUrl: './app.component.html',
  styleUrls: ['./app.component.scss'],
  imports: [
    TopnavComponent,
    NgClass,
    SidenavComponent,
    RouterOutlet,
    ToasterComponent,
    ConfirmDialog,
  ],
})
export class AppComponent implements OnInit {
  private fileSvc = inject(FileService);
  public appService = inject(AppService);
  public authService = inject(AuthService);
  private router = inject(Router);

  title: string = 'hrms-web';
  isExpanded: boolean = AppComponent.readSidebarPref();
  loggedIn: boolean = false;
  currUser;
  showShell = true;
  private readonly layoutlessPrefixes = ['/careers', '/login'];
  private static readonly SIDEBAR_PREF_KEY = 'zelushr.sidebar.expanded';

  toggleSidebar(): void {
    this.isExpanded = !this.isExpanded;
    try {
      localStorage.setItem(AppComponent.SIDEBAR_PREF_KEY, String(this.isExpanded));
    } catch {
      // localStorage may be unavailable (private mode, sandboxed iframe) — ignore.
    }
  }

  private static readSidebarPref(): boolean {
    try {
      return localStorage.getItem(AppComponent.SIDEBAR_PREF_KEY) === 'true';
    } catch {
      return false;
    }
  }

  ngOnInit(): void {
    this.currUser = this.authService.user;
    this.updateLayoutMode(this.router.url);
    this.router.events
      .pipe(filter((event): event is NavigationEnd => event instanceof NavigationEnd))
      .subscribe((event) => this.updateLayoutMode(event.urlAfterRedirects));
  }

  navigate(route: string) {
    this.router.navigate([route]);
  }

  logout() {
    this.currUser = null;
    this.loggedIn = false;
    this.authService.logout();
  }

  get isLoggedIn() {
    return this.authService.userInfo != null;
  }

  get logoUrl() {
    return this.fileSvc.getLogoUrl();
  }

  private updateLayoutMode(url: string) {
    this.showShell = !this.layoutlessPrefixes.some((prefix) => url.startsWith(prefix));
  }
}
